<template>
  <div class="outer-component" :class="{ hidden: hidden }">
    <div class="tab-bar">
      <router-link
        class="icon-with-title"
        :class="{ selected: homeTabSelected() }"
        to="/"
        @click.native="collapseCreate"
      >
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 1L17 6V18H13V13C13 11.9456 12.1841 11.0818 11.1493 11.0055L11 11H7C5.89543 11 5 11.8954 5 13V18H1V6L9 1Z"
            fill="#D5CFF5"
            stroke="#D5CFF5"
            stroke-width="2"
            stroke-linejoin="round"
            class="icon-with-title icon"
            style="{margin-top: 10px;}"
          />
        </svg>
        <span class="text">Home</span>
        <div class="indicator-bar" v-if="homeTabSelected()">
          <lottie-animation
            :path="
              smallScreen
                ? `../../tab-indicator-mobile.json`
                : `../../tab-indicator.json`
            "
            :loop="false"
            :key="smallScreen ? 'small-home' : 'home'"
          />
        </div>
      </router-link>
      <div class="link-wrapper" v-click-outside="collapseCreate">
        <div
          class="icon-with-title"
          :class="{ selected: createTabSelected }"
          @click="toggleCreate"
        >
          <div
            class="icon-animation-wrapper"
            :class="{ 'icon-selected': createTabSelected }"
          >
            <lottie-animation
              :key="`create-anim-${createTabSelected}`"
              :path="
                createTabSelected
                  ? 'create-icon-active.json'
                  : `create-icon.json`
              "
              :loop="false"
              :width="38"
              :height="38"
              @AnimControl="createAnimationController"
            />
          </div>
          <span class="text">Create</span>
          <div v-if="createTabSelected" class="indicator-bar">
            <lottie-animation
              :path="
                smallScreen
                  ? `../../tab-indicator-mobile.json`
                  : `../../tab-indicator.json`
              "
              :loop="false"
              :key="smallScreen ? 'small-create' : 'create'"
            />
          </div>
        </div>
        <div class="dropdown-wrapper">
          <div class="create-dropdown" :class="{ expanded: createTabExpanded }">
            <Button
              variant="secondary"
              class="dropdown-button"
              :action="onCreateSong"
            >
              Song
            </Button>
            <Button
              variant="secondary"
              class="dropdown-button"
              :action="onCreateRelease"
            >
              Release
            </Button>
          </div>
        </div>
      </div>
      <router-link
        class="icon-with-title"
        :class="{ selected: libraryTabSelected() }"
        to="/library"
        @click.native="collapseCreate"
      >
        <svg
          width="21"
          height="22"
          viewBox="0 0 21 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.03706 16.6905L6.56879 16.7244V16.1916V16.169V16.1464V16.124V16.1016V16.0792V16.0569V16.0346V16.0124V15.9903V15.9682V15.9461V15.9241V15.9022V15.8803V15.8584V15.8366V15.8149V15.7932V15.7716V15.75V15.7285V15.707V15.6855V15.6641V15.6428V15.6215V15.6003V15.5791V15.5579V15.5369V15.5158V15.4948V15.4739V15.453V15.4321V15.4113V15.3905V15.3698V15.3492V15.3285V15.308V15.2874V15.267V15.2465V15.2261V15.2058V15.1855V15.1652V15.145V15.1248V15.1047V15.0846V15.0646V15.0446V15.0247V15.0047V14.9849V14.9651V14.9453V14.9255V14.9059V14.8862V14.8666V14.847V14.8275V14.808V14.7886V14.7692V14.7498V14.7305V14.7112V14.6919V14.6727V14.6536V14.6344V14.6153V14.5963V14.5773V14.5583V14.5394V14.5205V14.5016V14.4828V14.464V14.4453V14.4265V14.4079V14.3892V14.3706V14.3521V14.3335V14.315V14.2966V14.2782V14.2598V14.2414V14.2231V14.2048V14.1866V14.1683V14.1502V14.132V14.1139V14.0958V14.0778V14.0597V14.0418V14.0238V14.0059V13.988V13.9701V13.9523V13.9345V13.9168V13.899V13.8813V13.8637V13.846V13.8284V13.8108V13.7933V13.7757V13.7583V13.7408V13.7234V13.706V13.6886V13.6712V13.6539V13.6366V13.6193V13.6021V13.5849V13.5677V13.5506V13.5334V13.5163V13.4992V13.4822V13.4652V13.4482V13.4312V13.4142V13.3973V13.3804V13.3635V13.3467V13.3298V13.313V13.2963V13.2795V13.2628V13.246V13.2294V13.2127V13.196V13.1794V13.1628V13.1463V13.1297V13.1132V13.0966V13.0802V13.0637V13.0472V13.0308V13.0144V12.998V12.9816V12.9653V12.9489V12.9326V12.9163V12.9001V12.8838V12.8676V12.8513V12.8351V12.819V12.8028V12.7866V12.7705V12.7544V12.7383V12.7222V12.7061V12.6901V12.674V12.658V12.642V12.626V12.6101V12.5941V12.5781V12.5622V12.5463V12.5304V12.5145V12.4986V12.4828V12.4669V12.4511V12.4353V12.4195V12.4037V12.3879V12.3721V12.3563V12.3406V12.3248V12.3091V12.2934V12.2777V12.262V12.2463V12.2306V12.215V12.1993V12.1836V12.168V12.1524V12.1368V12.1211V12.1055V12.0899V12.0744V12.0588V12.0432V12.0276V12.0121V11.9965V11.981V11.9654V11.9499V11.9344V11.9189V11.9034V11.8878V11.8723V11.8568V11.8413V11.8259V11.8104V11.7949V11.7794V11.7639V11.7485V11.733V11.7176V11.7021V11.6866V11.6712V11.6557V11.6403V11.6248V11.6094V11.5939V11.5785V11.5631V11.5476V11.5322V11.5167V11.5013V11.4859V11.4704V11.455V11.4395V11.4241V11.4087V11.3932V11.3778V11.3623V11.3469V11.3314V11.316V11.3005V11.2851V11.2696V11.2542V11.2387V11.2232V11.2078V11.1923V11.1768V11.1613V11.1458V11.1303V11.1148V11.0993V11.0838V11.0683V11.0528V11.0373V11.0217V11.0062V10.9907V10.9751V10.9595V10.944V10.9284V10.9128V10.8972V10.8816V10.866V10.8504V10.8348V10.8192V10.8035V10.7879V10.7722V10.7566V10.7409V10.7252V10.7095V10.6938V10.6781V10.6624V10.6466V10.6309V10.6151V10.5993V10.5836V10.5678V10.552V10.5361V10.5203V10.5044V10.4886V10.4727V10.4568V10.4409V10.425V10.4091V10.3931V10.3772V10.3612V10.3452V10.3292V10.3132V10.2972V10.2811V10.265V10.249V10.2329V10.2168V10.2006V10.1845V10.1683V10.1521V10.1359V10.1197V10.1035V10.0872V10.0709V10.0546V10.0383V10.022V10.0057V9.98929V9.9729V9.95649V9.94006V9.92361V9.90714V9.89065V9.87414V9.85761V9.84106V9.82448V9.80788V9.79126V9.77462V9.75796V9.74127V9.72456V9.70783V9.69108V9.6743V9.6575V9.64067V9.62382V9.60695V9.59005V9.57312V9.55618V9.5392V9.5222V9.50518V9.48813V9.47105V9.45395V9.43682V9.41967V9.40249V9.38528V9.36804V9.35078V9.33349V9.31617V9.29883V9.28145V9.26405V9.24662V9.22916V9.21167V9.19415V9.1766V9.15903V9.14142V9.12378V9.10612V9.08842V9.07069V9.05293V9.03514V9.01732V8.99947V8.98158V8.96366V8.94572V8.92774V8.90972V8.89168V8.8736V8.85548V8.83734V8.81916V8.80095V8.7827V8.76442V8.7461V8.72775V8.70937V8.69095V8.6725V8.65401V8.63548V8.61692V8.59832V8.57969V8.56102V8.54231V8.52357V8.50479V8.48597V8.46711V8.44822V8.42929V8.41032V8.39131V8.37227V8.35318V8.33406V8.3149V8.2957V8.27645V8.25717V8.23785V8.21849V8.19909V8.17965V8.16017V8.14064V8.12108V8.10147V8.08182V8.06213V8.0424V8.02263V8.00281V7.98295V7.96305V7.94311V7.92312V7.90309V7.88301V7.86289V7.84273V7.82252V7.80227V7.78198V7.76163V7.74125V7.72082V7.70034V7.67982V7.65925V7.63863V7.61797V7.59726V7.57651V7.55571V7.53486V7.51396V7.49302V7.47203V7.45099V7.4299V7.40877V7.38758V7.36635V7.34507V7.32373V7.30235V7.28092V7.25944V7.23791V7.21633V7.1947V7.17302V7.15128V7.1295C6.56879 6.61916 6.56909 6.24067 6.59125 5.93762C6.61336 5.63531 6.65499 5.4533 6.71354 5.32576C6.81379 5.10738 7.01549 4.92832 7.77639 4.62558C10.8804 3.39056 13.2691 2.60542 16.0358 1.69607C16.8769 1.41962 17.7529 1.13168 18.6946 0.816138L18.6951 0.815958C18.7738 0.789501 19.0273 0.777019 19.2507 0.910704C19.43 1.01797 19.66 1.26278 19.66 1.88833V1.8944V1.90053V1.90672V1.91298V1.91929V1.92566V1.9321V1.93859V1.94515V1.95176V1.95844V1.96518V1.97197V1.97883V1.98575V1.99273V1.99977V2.00687V2.01404V2.02126V2.02854V2.03588V2.04329V2.05075V2.05828V2.06587V2.07351V2.08122V2.08899V2.09682V2.10471V2.11265V2.12067V2.12874V2.13687V2.14506V2.15331V2.16163V2.17V2.17844V2.18693V2.19549V2.2041V2.21278V2.22152V2.23032V2.23918V2.2481V2.25708V2.26612V2.27522V2.28438V2.29361V2.30289V2.31223V2.32164V2.3311V2.34063V2.35022V2.35986V2.36957V2.37934V2.38917V2.39906V2.40901V2.41902V2.42909V2.43922V2.44942V2.45967V2.46998V2.48036V2.49079V2.50129V2.51185V2.52246V2.53314V2.54388V2.55468V2.56554V2.57646V2.58744V2.59848V2.60959V2.62075V2.63197V2.64326V2.6546V2.66601V2.67747V2.689V2.70059V2.71223V2.72394V2.73571V2.74754V2.75943V2.77138V2.78339V2.79547V2.8076V2.81979V2.83205V2.84436V2.85674V2.86917V2.88167V2.89423V2.90684V2.91952V2.93226V2.94506V2.95792V2.97084V2.98382V2.99687V3.00997V3.02313V3.03636V3.04964V3.06299V3.07639V3.08986V3.10339V3.11698V3.13062V3.14433V3.1581V3.17193V3.18582V3.19978V3.21379V3.22786V3.24199V3.25619V3.27044V3.28476V3.29913V3.31357V3.32807V3.34263V3.35724V3.37192V3.38666V3.40146V3.41632V3.43125V3.44623V3.46127V3.47637V3.49154V3.50676V3.52205V3.53739V3.5528V3.56827V3.5838V3.59938V3.61503V3.63074V3.64651V3.66234V3.67824V3.69419V3.7102V3.72627V3.74241V3.7586V3.77486V3.79117V3.80755V3.82399V3.84048V3.85704V3.87366V3.89034V3.90708V3.92388V3.94074V3.95767V3.97465V3.99169V4.0088V4.02596V4.04319V4.06047V4.07782V4.09523V4.11269V4.13022V4.14781V4.16546V4.18317V4.20094V4.21877V4.23667V4.25462V4.27263V4.29071V4.30884V4.32704V4.34529V4.36361V4.38199V4.40042V4.41892V4.43748V4.4561V4.47478V4.49352V4.51232V4.53119V4.55011V4.56909V4.58814V4.60724V4.62641V4.64563V4.66492V4.68426V4.70367V4.72314V4.74267V4.76226V4.78191V4.80162V4.82139V4.84122V4.86112V4.88107V4.90108V4.92116V4.94129V4.96149V4.98175V5.00206V5.02244V5.04288V5.06338V5.08394V5.10456V5.12524V5.14598V5.16678V5.18764V5.20857V5.22955V5.2506V5.2717V5.29287V5.31409V5.33538V5.35673V5.37814V5.39961V5.42114V5.44273V5.46438V5.48609V5.50786V5.52969V5.55159V5.57354V5.59555V5.61763V5.63977V5.66196V5.68422V5.70654V5.72892V5.75135V5.77385V5.79641V5.81903V5.84172V5.86446V5.88726V5.91012V5.93305V5.95603V5.97908V6.00218V6.02535V6.04858V6.07186V6.09521V6.11862V6.14209V6.16562V6.18921V6.21286V6.23658V6.26035V6.28418V6.30808V6.33203V6.35605V6.38012V6.40426V6.42845V6.45271V6.47703V6.50141V6.52585V6.55035V6.57491V6.59953V6.62421V6.64896V6.67376V6.69862V6.72355V6.74853V6.77358V6.79868V6.82385V6.84908V6.87437V6.89972V6.92513V6.9506V6.97613V7.00172V7.02737V7.05308V7.07886V7.10469V7.13058V7.15654V7.18255V7.20863V7.23477V7.26097V7.28722V7.31354V7.33992V7.36636V7.39286V7.41942V7.44605V7.47273V7.49947V7.52628V7.55314V7.58007V7.60705V7.6341V7.6612V7.68837V7.7156V7.74289V7.77024V7.79765V7.82512V7.85265V7.88024V7.9079V7.93561V7.96338V7.99122V8.01911V8.04707V8.07508V8.10316V8.1313V8.1595V8.18776V8.21607V8.24445V8.2729V8.3014V8.32996V8.35858V8.38726V8.41601V8.44481V8.47368V8.5026V8.53159V8.56064V8.58974V8.61891V8.64814V8.67743V8.70678V8.73619V8.76566V8.79519V8.82479V8.85444V8.88415V8.91393V8.94376V8.97366V9.00362V9.03363V9.06371V9.09385V9.12405V9.15431V9.18463V9.21501V9.24545V9.27595V9.30651V9.33714V9.36782V9.39856V9.42937V9.46023V9.49116V9.52215V9.55319V9.5843V9.61547V9.6467V9.67799V9.70934V9.74075V9.77223V9.80376V9.83535V9.867V9.89872V9.93049V9.96233V9.99423V10.0262V10.0582V10.0903V10.1224V10.1546V10.1869V10.2192V10.2516V10.284V10.3165V10.3491V10.3817V10.4144V10.4471V10.4799V10.5128V10.5457V10.5787V10.6118V10.6449V10.6781V10.7113V10.7446V10.7779V10.8113V10.8448V10.8783V10.9119V10.9456V10.9793V11.0131V11.0469V11.0808V11.1148V11.1488V11.1829V11.217V11.2512V11.2855V11.3198V11.3542V11.3886V11.4231V11.4577V11.4923V11.527V11.5617V11.5965V11.6314V11.6663V11.7013V11.7364V11.7715V11.8066V11.8419V11.8772V11.9125V11.9479V11.9834V12.0189V12.0545V12.0902V12.1259V12.1617V12.1975V12.2334V12.2694V12.3054V12.3415V12.3776V12.4138V12.4501V12.4864V12.5228V12.5592V12.5957V12.6323V12.6689V12.7056V12.7423V12.7792V12.816V12.8529V12.8899V12.927C19.66 15.6831 17.961 17.1529 16.2937 17.5239C15.4479 17.7121 14.64 17.6112 14.0649 17.2861C13.5119 16.9735 13.1445 16.4414 13.1445 15.6485C13.1445 14.4757 13.5487 13.733 14.2894 13.2909C15.0754 12.8217 16.3314 12.6339 18.1454 12.8301L18.6991 12.89V12.333V5.14571V4.43494L18.0302 4.67513C16.4089 5.25722 14.7064 5.82704 12.9851 6.40318L12.9351 6.41992C11.1987 7.0011 9.44411 7.58875 7.74655 8.19872L7.41563 8.31762V8.66926V17.736C7.41563 19.4408 5.94964 20.7191 4.31393 21.0942C3.50921 21.2787 2.74106 21.2208 2.17742 20.9345C1.6402 20.6616 1.24045 20.1596 1.16575 19.3142C1.08324 18.3805 1.25731 17.7999 1.51926 17.4303C1.78083 17.0612 2.18038 16.8313 2.69276 16.7002C3.21016 16.5678 3.80708 16.5459 4.40629 16.5696C4.78706 16.5846 5.12707 16.6147 5.44675 16.643C5.64998 16.6611 5.845 16.6783 6.03706 16.6905Z"
            fill="#D5CFF5"
            stroke="#D5CFF5"
            class="icon-with-title icon"
          />
        </svg>
        <span class="text">Library</span>
        <div v-if="libraryTabSelected()" class="indicator-bar">
          <lottie-animation
            :path="
              smallScreen
                ? `../../tab-indicator-mobile.json`
                : `../../tab-indicator.json`
            "
            :loop="false"
            :key="smallScreen ? 'small-library' : 'library'"
          />
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Button from "./Button";
import { ROUTES } from "@/router/routes";

export default {
  name: "tabBar",
  props: {
    selectedTab: {
      type: String,
      default: "home",
      description: "Selected tab item"
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Button
  },
  watch: {
    selectedTab(value) {
      // console.log(value);
    },
    createTabExpanded(expanded) {
      if (this.animation) {
        if (expanded) {
          this.animation.goToAndStop(0, true);
          this.animation.setDirection(1);
          this.animation.play();
        } else {
          this.animation.goToAndStop(20, true);
          this.animation.setDirection(-1);
          this.animation.play();
        }
      }
    }
  },
  data: () => ({
    windowWidth: window.innerWidth,
    createTabExpanded: false,
    animation: null
  }),
  computed: {
    smallScreen() {
      return this.windowWidth < 1024;
    },
    createTabSelected() {
      return (
        this.selectedTab === "style" ||
        this.selectedTab === "create" ||
        this.selectedTab === "createWithId" ||
        this.selectedTab === "releaseCreate"
      );
    }
  },
  methods: {
    homeTabSelected() {
      return this.selectedTab === "home";
    },
    libraryTabSelected() {
      return this.selectedTab === "Library" || this.selectedTab === "library";
    },
    collapseCreate() {
      this.createTabExpanded = false;
    },
    toggleCreate() {
      this.createTabExpanded = !this.createTabExpanded;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    onCreateSong() {
      this.$store.dispatch("creator/resetState");
      this.$router.push({ path: ROUTES.create.path });
      this.createTabExpanded = false;
    },
    onCreateRelease() {
      this.$router.push({ path: ROUTES.releaseCreate.path });
      this.createTabExpanded = false;
    },
    createAnimationController(instance) {
      this.animation = instance;
      this.animation.stop();
      this.animation.onComplete = () => {
        this.animation.goToAndStop(0, true);
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style scoped lang="scss">
.outer-component {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: fixed;
  bottom: 0px;
  @media (min-width: 1024px) {
    top: 0px;
    width: 380px;
  }
  height: 64px;
  z-index: 1000;
}
.tab-bar {
  z-index: 2;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  max-width: 1024px;
  background-color: #09090e;
  @media (min-width: 1024px) {
    max-width: 380px;
  }
}

.icon-with-title {
  display: flex;
  cursor: pointer;
  width: fit-content;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: #f2eeff;
  .text {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 500;
    font-family: "objektiv-mk2", sans-serif;
  }
  @media (min-width: 1024px) {
    flex-direction: row;
    .icon {
      margin-right: 10px;
    }
    .text {
      margin-left: 10px;
      font-size: 14px;
    }
  }
  @media (hover: hover) {
    &:hover {
      color: lighten(#8f7af0, 8%);
      .icon {
        fill: lighten(#8f7af0, 8%);
        stroke: lighten(#8f7af0, 8%);
      }
    }
  }
}

.selected {
  color: #f81b55;
  .icon {
    fill: #f81b55;
    stroke: #f81b55;
  }
  @media (hover: hover) {
    &:hover {
      color: darken(#f81b55, 15%);
      .icon {
        fill: darken(#f81b55, 15%);
        stroke: darken(#f81b55, 15%);
      }
    }
  }
  .indicator-bar {
    display: block;
  }
}

.indicator-bar {
  position: absolute;
  bottom: 0px;
  width: 72px;
  height: auto;
  @media (min-width: 1024px) {
    top: 0px;
    width: 122px;
    height: 36px;
  }
}

.hidden {
  display: hidden;
}

.link-wrapper {
  display: flex;
  width: fit-content;
  align-items: center;
  flex-direction: column-reverse;
  justify-content: center;
  @media (min-width: 1024px) {
    flex-direction: column;
  }
}

.dropdown-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  @media (min-width: 1024px) {
    flex-direction: column;
  }
}

.create-dropdown {
  display: flex;
  flex-direction: column;
  position: absolute;
  margin-bottom: 15px;
  height: 95px;
  max-height: 0;
  overflow: hidden;
  justify-content: space-around;
  transition: all 0.25s ease-in-out;
  @media (min-width: 1024px) {
    margin-top: 15px;
    margin-bottom: 0;
  }
}

.expanded {
  max-height: 95px;
}

.dropdown-button {
  width: 100px;
}

.icon-animation-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -9px;
}
</style>
